import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, TemplateRef } from '@angular/core';

import { FunctionProp } from '../../../core/types/common-wrap';
import { NzCalendarI18nInterface } from '../../../i18n/nz-i18n.interface';
import { DisabledDateFn, PanelMode } from '../../standard-types';
import { CandyDate } from '../candy-date';

@Component({
  selector: 'inner-popup',
  template: `<calendar-header [(panelMode)]="panelMode" (panelModeChange)="panelModeChange.emit($event)" [(value)]="value" (valueChange)="headerChange.emit($event)" [locale]="locale" [showTimePicker]="showTimePicker" [enablePrev]="enablePrev" [enableNext]="enableNext" ></calendar-header> <ng-container *ngIf="showTimePicker && timeOptions"> <nz-time-picker-panel [nzInDatePicker]="true" [ngModel]="value.nativeDate" (ngModelChange)="onSelectTime($event)" [format]="timeOptions.nzFormat" [nzHourStep]="timeOptions.nzHourStep" [nzMinuteStep]="timeOptions.nzMinuteStep" [nzSecondStep]="timeOptions.nzSecondStep" [nzDisabledHours]="timeOptions.nzDisabledHours" [nzDisabledMinutes]="timeOptions.nzDisabledMinutes" [nzDisabledSeconds]="timeOptions.nzDisabledSeconds" [nzHideDisabledOptions]="timeOptions.nzHideDisabledOptions" [nzDefaultOpenValue]="timeOptions.nzDefaultOpenValue" [nzAddOn]="timeOptions.nzAddOn" ></nz-time-picker-panel> </ng-container> <div class="{{ prefixCls }}-body"> <date-table [showWeek]="showWeek" [value]="value" (valueChange)="onSelectDate($event)" showWeekNumber="false" [disabledDate]="disabledDate" [dateRender]="dateRender" [selectedValue]="selectedValue" [hoverValue]="hoverValue" (dayHover)="dayHover.emit($event)" ></date-table> </div>`
})

export class InnerPopupComponent implements OnInit, OnChanges {
  @Input() showWeek: boolean;

  @Input() locale: NzCalendarI18nInterface;
  @Input() showTimePicker: boolean;
  @Input() timeOptions: object;
  @Input() enablePrev: boolean;
  @Input() enableNext: boolean;
  @Input() disabledDate: DisabledDateFn;
  @Input() dateRender: FunctionProp<TemplateRef<Date> | string>;
  @Input() selectedValue: CandyDate[]; // Range ONLY
  @Input() hoverValue: CandyDate[]; // Range ONLY

  @Input() panelMode: PanelMode;
  @Output() panelModeChange = new EventEmitter<PanelMode>();

  @Input() value: CandyDate;

  @Output() headerChange = new EventEmitter<CandyDate>(); // Emitted when user changed the header's value
  @Output() selectDate = new EventEmitter<CandyDate>(); // Emitted when the date is selected by click the date panel
  @Output() selectTime = new EventEmitter<CandyDate>();
  @Output() dayHover = new EventEmitter<CandyDate>(); // Emitted when hover on a day by mouse enter

  prefixCls: string = 'ant-calendar';

  constructor() { }

  ngOnInit(): void { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.value && !this.value) {
      this.value = new CandyDate();
    }
  }

  onSelectTime(date: Date): void {
    this.selectTime.emit(new CandyDate(date));
  }

  // The value real changed to outside
  onSelectDate(date: CandyDate | Date): void {
    // this.value = date instanceof CandyDate ? date : new CandyDate(date);
    const value  = date instanceof CandyDate ? date : new CandyDate(date);
    this.selectDate.emit(value);
  }
}
